import { BASE_REPORT_FLOW } from "../constants/reportFlow";

/**
 * @param {"skit"|"comment"|"thread"|"response"} kind
 * @returns {Array} a cloned flow with the first step’s title updated
 */
export function getReportFlow(kind) {
    return BASE_REPORT_FLOW.map((step) =>
      step.id === "why"
        ? { ...step, title: `Why are you reporting this ${kind}?` }
        : step
    );
  }